module.exports = __webpack_public_path__ + "static/85fdb29f.tmallClose_2.png";